import { axios } from '@/services/axios';

export const deleteServiceCategory = (serviceCategoryId) => {
    return axios.delete(`/servicecategory/${serviceCategoryId}`);
};
